// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var BootstrapBadgeTheme;
(function (BootstrapBadgeTheme) {
    BootstrapBadgeTheme["Black"] = "black";
    BootstrapBadgeTheme["Blue"] = "blue";
    BootstrapBadgeTheme["Green"] = "green";
    BootstrapBadgeTheme["Red"] = "red";
    BootstrapBadgeTheme["White"] = "white";
    BootstrapBadgeTheme["Yellow"] = "yellow";
})(BootstrapBadgeTheme || (BootstrapBadgeTheme = {}));
